export enum StartLogsPageRouteAction {
  RUNNING_CONTROLS = 'RUNNING_CONTROLS',
}
